module.exports = __webpack_public_path__ + "img/v1-library.cb1a204c.png";